export const spring = {
  fast: { type: 'spring' as const, duration: 0.08, bounce: 0 },
  moderate: { type: 'spring' as const, duration: 0.16, bounce: 0 },
} as const
